import { OhsAttachment } from 'global-components/form/fields/attachments/OhsAttachmentModels';
import { ModuleType, OhsModuleCreateBy } from 'global-services/constants/OhsObject';
import { OhsTier } from 'global-services/constants/tier/OhsTier';

import OhsInjuryMgmtRecord from './OhsInjuryMgmtRecord';

export default class OhsInjuryMgmtTaskRecord {
  _id: string;

  reference: string | null;

  attachments: OhsAttachment[];

  previousAttachments?: OhsAttachment[];

  category: string;

  subcategory: string;

  categoryOther: string;

  subcategoryOther: string;

  complete: boolean;

  dateCreated: string;

  dateCompleted: string;

  dateDue: string;

  dateSignedoff: string;

  dateDueReference: string;

  description: string;

  completionNotes: string;

  signatures: OhsAttachment[];

  signedoffBy: OhsModuleCreateBy;

  createdBy: OhsModuleCreateBy;

  tier?: OhsTier | null;

  title: string;

  type: string;

  tzDateSignedoff: string;

  tzDateCreated: string;

  timeCompleted?: { hours: number; minutes: number };

  timeSignedoff?: { hours: number; minutes: number };

  save?: boolean;

  for?: { _id: string; type: ModuleType.InjurySubMaster; save?: any };

  links?: string[];

  cusvals?: any;

  sysfields?: any;

  layout?: any;

  masterOwner?: {
    _id: string;
    type: ModuleType.Injury;
    template: { type: ModuleType.InjuryTemplate; _id: string };
  };

  partialChronology: OhsInjuryMgmtRecord[];

  constructor(tier?: OhsTier) {
    this.reference = null;
    this.attachments = new Array<OhsAttachment>();
    this.category = '';
    this.categoryOther = '';
    this.subcategory = '';
    this.subcategoryOther = '';
    this.complete = true;
    this.dateCompleted = '';
    this.dateCreated = '';
    this.dateDue = '';
    this.dateSignedoff = '';
    this.dateDueReference = '';
    this.description = '';
    this._id = '';
    this.completionNotes = '';
    this.signatures = new Array<OhsAttachment>();
    this.signedoffBy = new OhsModuleCreateBy();
    this.createdBy = new OhsModuleCreateBy();
    this.type = ModuleType.Task;
    this.tier = tier;
    this.title = '';
    this.tzDateSignedoff = '';
    this.tzDateCreated = '';
    this.for = undefined;
    this.partialChronology = [];
  }
}
